import enUS from './lang/en-US'
import zhCN from './lang/zh-CN'

import { createI18n } from 'vue-i18n'

const messages = {
  'en-us': enUS,
  'zh-ch': zhCN,
}

const i18n = createI18n({
  locale: localStorage.getItem('leviy-lang') || 'zh-ch',
  legacy: false, // composition API
  messages,
})

export default i18n
